import { SortOrders } from '../../shared/models/sort-orders';
import { AppStore } from '../../shared/store/lookup-store.service';
import { LocationFilter } from './location-filter';

export class JobFilter {
    constructor() {
        this.pageNumber = 1;
        this.sortBy = SortOrders.Recent;
        this.locationFilter = new LocationFilter();
    }

    keyword: string;
    location: string;
    datePostedPeriod: number|null;
    sectors: string[] = [];
    jobTypes: string[] = [];
    experience: number|null;
    salaryTypeId: string;
    minimumSalary: number|null;
    maximumSalary: number|null;
    qualifications: string[] = [];
    sortBy: SortOrders;
    pageNumber: number;
    locationFilter: LocationFilter;

    updateLocationFilter(lookupStore: AppStore): void {
        if(this.location) {
            let cityCountry = this.location.split(',');
            if(cityCountry.length > 0)
                this.locationFilter.city = cityCountry[0].trim();
            if(cityCountry.length > 1) {
                let country = lookupStore.getCountryByName(cityCountry[1].trim());
                if(country) {
                    this.locationFilter.countryId = country.id;
                    this.locationFilter.country = country.name;
                }
            }

        }
    }
}
